import { ParsedToken, User } from "firebase/auth";
import React, { createContext, useReducer } from "react";
import { reducer } from "./reducer";
import { Actions } from "./types";
import { itmType } from "../../../material/statesProvider/materialContext";
import { responseType } from "../../../../../../../utils/formTypes";

export type InitialStateType = {
  itm: itmType | null;
  supplier: responseType | null;
};

export const initialState: InitialStateType = {
  itm: null,
  supplier: null,
};

const StockEntryContext = createContext<{
  state: InitialStateType;
  dispatch: React.Dispatch<Actions>;
}>({
  state: initialState,
  dispatch: () => null,
});
interface Props {
  children: React.ReactNode;
}
const AppProvider: React.FC<Props> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <StockEntryContext.Provider value={{ dispatch, state }}>
      {children}
    </StockEntryContext.Provider>
  );
};

export { AppProvider, StockEntryContext };
